import {
  DEFAULT_DRILL,
  DEFAULT_FILTER_LIMIT,
  DEFAULT_FILTERS,
  DEFAULT_MODE,
  HARD_LIMIT,
  PATH_STRING_SEPARATOR,
  CONDITIONS_META,
} from './config';
import {
  WEEKDAYS
} from './datetime';

import {
  isStrictDimention
} from '../core/type-dimensions';
import {
  getFilterIcon
} from '../common/filter-mode';

import moment from 'moment';

const FILTER_COUNT = 1;
const DEFAULT_NAME = gettext('Фильтр');

export class Filter {

  constructor(name) {
    this.name = name || (DEFAULT_NAME + ' ' + FILTER_COUNT);
    this.drilldown = window.defaultDimension ? [defaultDimension] : [];
  }

  /**
   * Set subview type
   * one of: explore, series, chart
   */

  setMode(mode) {
    if (this.measure === 'total_elements' && mode !== 'summ-stat') delete this.measure;
    if (this.mode !== mode) {
      if (this.isDashboard) this.content_type = 'filter';
      this.changed();
    }
    this.mode = mode;
  }

  get customLimit() {
    return this.hasOwnProperty('limit') ? this.limit : 0;
  }

  set customLimit(limit) {
    const l = parseInt(limit, 10);
    if (isNaN(l) || !l) delete this.limit;
    else this.limit = l;
  }

  get isContainer() {
    return this.content_type === 'folder' || this.isCard || this.isDashboard;
  }

  get isPolitic() {
    // return this.content_type !== 'filter' && !this.isContainer && !this.isAnalyticPolitic;
    return this.content_type !== 'filter' && !this.isContainer && this.content_type !== 'filteraggregatealertfilter';
  }

  get isAnalyticPolitic() {
    return this.content_type === 'corpusprocessfilter';
  }

  get isExplore() {
    return this.mode === 'explore';
  }

  get isChart() {
    return this.mode === 'chart';
  }

  get isChartArea() {
    return this.mode === 'chart-area';
  }

  get isRadar() {
    return this.mode === 'radar';
  }

  get isEventRiver() {
    return this.mode === 'event-river';
  }

  get isViewChat() {
    return this.isExplore && this.listType === 'chat-viewer';
  }

  get isStat() {
    return this.mode === 'stat';
  }

  get isSummStat() {
    return this.mode === 'summ-stat';
  }

  get isReport() {
    return this.mode === 'report';
  }

  get isReports() {
    return this.mode === 'reports';
  }

  // isFilterEdit() {
  //   return this.modal === 'filter-edit';
  // }


  get isTree() {
    return this.mode === 'tree';
  }

  get isGraph() {
    return this.isReports && this.url === '/analytics/report/graph/wizard/';
  }

  get isAnalysis() {
    return this.isReport || this.isStat || this.isSummStat || this.isChartArea ||
      this.isChart || this.isTree || this.isRadar || this.isEventRiver;
  }

  get isAnomaly() {
    return this.isReports && this.url === '/analytics/report/anomaly/';
  }

  get isCatalog() {
    return this.children.length && this.isExplore && this.content_type === 'folder';
  }

  get isCard() {
    return this.content_type === 'dimensioncardfilter' || this.mode === 'card'; //(this.isReports && this.url === '/analytics/card/' || this.content_type === 'dimensioncardfilter') ||
  }

  get isCardFilter() {
    return this.isCard && !!this.filters && this.filters[0] &&
      this.filters.filter(f => f.dimension === this.filters[0].dimension).length === 1;
  }

  get isDashboard() {
    return this.mode === 'dashboard' || this.content_type === 'dashboard' ||
      this.isDimensionCard;
  }

  get isCardOrDashboard() {
    return this.isDashboard || this.isCard;
  }

  get isCardAccount() {
    return this.isCard && this.drilldow && this.drilldow[0] &&
      this.drilldown[0].startsWith('agent_account@');
  }

  get isDimensionCard() {
    return this.content_type === 'dimensioncardfilter' && !this.cardFilter &&
      this.children && this.children.length;
  }

  get isViewFacts() {
    return this.isExplore && (this.listType === 'table' ||
        this.listType === 'brief' || this.listType === 'thumblist') ||
      this.isReport;
  }

  get isViewStat() {
    return this.isStat || this.isChartArea || this.isChart ||
      this.isGraph ||
      this.isTree;
  }

  get isViewReport() {
    return this.isReports && !this.isGraph;
  }

  get hasQuery() {
    return this.query && this.query.rules && this.query.rules.length;
  }

  getIcon() {
    return getFilterIcon(this);
  }

  getFilterError() {
    const result = {
      fields: {},
      text: '',
      error: false,
    };
    const MAX_SAFE_INTEGER = 9007199254740991;
    if (this.content_type === 'policy' || this.content_type === 'deletepolicy' || this.isAnalyticPolitic) {
      if (this.filters && !this.filters.length && !this.hasQuery) {
        if (this.content_type === 'deletepolicy') {
          result.text = gettext('Пожалуйста, укажите данные для удаления создав фильтр в конструкторе.');
          return result;
        }
        result.text = gettext('Пожалуйста, ограничьте обьем обрабатываемых данных создав фильтр в конструкторе.');
        result.error = true;
        return result;
      }
    }
    if (this.send_threshold) {
      if (this.threshold_period < 0 || this.threshold_period >= MAX_SAFE_INTEGER) {
        result.fields.threshold_period = gettext('Неверное значение "Период порога срабатывания"!');
        result.error = true;
        return result;
      }
      if (this.threshold < 0 || this.threshold >= MAX_SAFE_INTEGER) {
        result.fields.threshold = gettext('Неверное значение "Достижение порога срабатывания"!');
        result.error = true;
        return result;
      }
    }
    result.text = this.getQueryError();
    result.error = !!result.text;
    return result;
  }

  getQueryError() {
    if (!this.hasQuery) return null;
    if (this.query.operator !== 'AND' && this.query.operator !== 'OR') return gettext('неправильный оператор ("operator")');
    const _isStrictDimention = isStrictDimention;
    const getRuleError = rule => {
      const allowSameValueLabel = (dim, hier) => {
        const allow = {
          agent_time: {
            hour: true,
            time_zone: true,
            y: true,
          }
        };
        return allow[dim] && allow[dim][hier];
      };

      if (rule.group) return rule.group.operator === 'AND' || rule.group.operator === 'OR' ? null : gettext('неправильный оператор ("operator")');
      if (!rule.condition) return gettext('отсутсвует условие ("condition")');
      if (!CONDITIONS_META[rule.condition]) return gettext('неправильное условие ("condition")');
      if (!rule.dimension) return gettext('отсутсвует "dimension"');
      if (!rule.hierarchy) return gettext('отсутсвует "hierarchy"');
      // if (!rule.value) return gettext('неверное значение') + ' ("value")';
      if (_isStrictDimention(rule.dimension, rule.hierarchy)) {
        if (!rule.label) return gettext('отсутствует значение');
        if (rule.value === rule.label && !allowSameValueLabel(rule.dimension, rule.hierarchy)) return gettext('неверное значение') + ` "${rule.label}"`;
      }
      // if (_isStrictDimention(rule.dimension, rule.hierarchy) && !rule.label && rule.value === rule.label) return gettext('неверное значение') + ` "${rule.label}"`;
      // if ((rule.condition === '=' || rule.condition === '!') && !rule.label) return gettext('неверное значение "label"');
      return null;
    };

    let errMessage = null;
    const iter = rules => {
      if (!rules.length) return null;
      rules.some(rule => {
        errMessage = getRuleError(rule);
        if (errMessage) return true;
        if (rule.group && rule.group.rules && rule.group.rules.length) return iter(rule.group.rules);
        return false;
      });
      return errMessage;

    };
    iter(this.query.rules);

    return errMessage;
  }

  setList(mode) {
    this.setMode('explore');
    this.listType = mode;
  }

  toggleSkipStat() {
    this.skipStat = !this.skipStat;
  }

  /**
   * Add drilldown (X) dimension
   */

  addDrilldown(dimension) {
    if (!this.drilldown || !this.drilldown.length) {
      this.drilldown = [dimension];
    } else {
      this.drilldown.push(dimension);
    }
  }

  /**
   * Set drilldown (X) dimension
   */
  replaceDrilldown(newDim, oldDim) {
    const ax = this.drilldown.indexOf(oldDim);
    if (ax !== -1) {
      this.drilldown[ax] = newDim;
    }
    this.cleanOrders();

  }

  setDrilldown(dimension) {
    //             console.log('Set drilldown', dimension);
    this.drilldown = [dimension];
    this.setOrder(dimension);
  }

  /**
   * Remove drilldown (X) dimension
   */

  cleanOrders() {
    this.order = null;
    this.orderDim = this.order;
    this.orders.splice(0, this.orders.length);
    this.orders.push('measure');
    this.orderDirs.splice(0, this.orderDirs.length);
    this.orderDirs.push('desc');
  }

  removeDrilldown(name) {
    let ax;
    if ((ax = this.drilldown.indexOf(name)) !== -1) {
      this.drilldown.splice(ax, 1);
    }
    this.cleanOrders();
  }

  /* True if filters has drilldown */
  hasDrilldown(name) {
    return this.drilldown.indexOf(name) !== -1;
  }

  /* add child filter */
  addChild(filter) {
    this.removeChild(filter);
    this.children.push(filter);
  }

  /* Remove child filter */
  removeChild(filter) {
    this.children = (this.children || []).filter(e => e.id != filter.id);
  }

  find(predicate) {
    if (predicate(this)) {
      return this;
    }
    for (let i = 0; i < this.children.length; ++i) {
      const child = this.children[i];
      const f = child.find(predicate);
      if (f) {
        return f;
      }
    }
  }

  typize(path) {
    if (!path) {
      path = this.name;
    } else {
      path = path + ' | ' + this.name;
    }
    this.saved = true;
    this._changed = undefined;
    this.path = path;
    // this.orders = ['measure'];
    // this.orderDirs = ['desc'];
    this.children = this.children.map(child => {
      child = Object.setPrototypeOf(child, Filter.prototype);
      child.typize(path);
      return child;
    });
  }

  getPathName() {
    return this.path || this.name;
  }

  isActive(drilldown_name) {
    const active = this.drilldown.indexOf(drilldown_name) >= 0;
    return active;
  }

  isParent(drilldown_name) {
    for (const index in this.drilldown) {
      const drill = this.drilldown[index];
      if (drill.split('@')[0] === drilldown_name.split('@')[0]) return true;
    }
    return false;
  }

  hasFilters() {
    return this.drilldown.length ||
      this.filters.length ||
      this.xaxis != null;
  }

  hasFilter(filter) {
    return this.filters.some(item =>
      item.dimension === filter.dimension && (item.value === filter.value ||
        (item.dimension === 'agent_agent@computer_name:computer_name' &&
          filter.value.split(PATH_STRING_SEPARATOR)[0] === item.value
        )));
  }

  removeContent_type() {
    if ([
        'filteraggregatealertfilter',
        // 'corpusprocessfilter'
      ].indexOf(this.content_type) === -1)
      delete this.content_type;
  }

  setOrder(dimension, attr) {
    this.orderDim = dimension;
    if (Filter.isTimeDimension(dimension)) {
      this.orderDir = 'desc';
      this.order = Filter.orderForTimeDimension(dimension);
    } else if (dimension === 'agent_time@hour:hour') {
      this.orderDir = 'asc';
      this.order = 'agent_time.hour';
    } else if (dimension === 'agent_time@weekday:weekday') {
      this.orderDir = 'asc';
      this.order = 'agent_time.weekday';
    } else {
      this.orderDir = 'desc';
      this.order = attr || 'record_count';
    }
    this.changed();
  }

  addKeyword(keyword) {
    this.filters = $.grep(this.filters, function(e) {
      return e.value == keyword;
    }, true);
    this.filters.push({
      'dimension': 'keyword',
      'value': keyword,
      'label': keyword,
    });
    this.changed();
  }

  setKeyword(keyword) {
    this.filters = $.grep(this.filters, function(e) {
      return e.dimension === 'keyword';
    }, true);
    keyword && this.filters.push({
      'dimension': 'keyword',
      'value': keyword,
      'label': keyword,
    });
    this.changed();
  }

  copyFrom(srcFilter, skipActive) {
    if (!skipActive) {
      angular.copy(srcFilter, this);
    } else {
      this.filters = srcFilter.filters.filter(filter =>
        !this.isActive(filter.dimension));
      [
        'id', 'mode', 'listType', 'xaxis', 'charttype',
        'name', 'timeFrom', 'timeTo',
      ].forEach(property => {
        this[property] = srcFilter[property];
      });
    }
  }

  addTimeFilter(date, level, isUTCtime) {
    if (!date) return;
    if (!isUTCtime) date = Filter.toUTCTime(date);
    this.addFilter(
      Filter.timeDimensionForLevel(level),
      Filter.valueForTime(date, level, true),
      Filter.labelForTime(date, level),
    );
  }

  setTimeFilter(date, level, isUTCtime) {
    if (!isUTCtime) date = Filter.toUTCTime(date);
    this.setFilter(
      Filter.timeDimensionForLevel(level),
      Filter.valueForTime(date, level),
      Filter.labelForTime(date, level),
    );
  }

  cleanFilter(dimension) {
    if (!dimension) return;
    if (typeof(dimension) === 'object') {
      dimension = dimension.dimension;
    }
    //             console.log('removeFilter', dimension, value );
    this.filters = this.filters.filter(filter =>
      filter.dimension !== dimension);
    this.changed();
  }

  addFilter(dimension, value, label, predicates) {
    if (!dimension) return;
    if (dimension instanceof Date)
      return this.addTimeFilter(dimension, value, true);
    this.removeFilter(dimension, value);
    if (dimension === 'agent_time@weekday:weekday') {
      label = WEEKDAYS[value];
    }
    this.filters.push({
      'dimension': dimension,
      'value': value,
      'label': label,
      'predicates': predicates ? predicates : [],
    });
    this.changed();
  }

  changed() {
    this._changed = true;
  }

  get isChanged() {
    return !!this._changed;
  }

  set isChanged(bool) {
    this._changed = bool ? true : undefined;
  }


  setFilter(dimension, value, label) {
    if (!dimension) return;
    if (dimension instanceof Date)
      return this.setTimeFilter(dimension, value, label);
    this.setOrder(dimension);
    this.filters = [{
      'dimension': dimension,
      'value': value,
      'label': label,
    }, ];
    this.changed();
  }

  removeFilter(dimension, value) {
    if (typeof(dimension) === 'object') {
      value = dimension.value;
      dimension = dimension.dimension;
    }
    if (!dimension) return;
    //             console.log('removeFilter', dimension, value );
    this.filters = this.filters.filter(filter =>
      filter.dimension !== dimension || (filter.value !== value && !(
        dimension === 'agent_agent@computer_name:computer_name' &&
        value.split(PATH_STRING_SEPARATOR)[0] === filter.value
      )));
    this.changed();
  }

  invertFilter(dimension, value) {
    if (typeof(dimension) === 'object') {
      value = dimension.value;
      dimension = dimension.dimension;
    }
    if (!dimension) return;
    this.filters.forEach(e => {
      if (e.dimension === dimension && e.value == value) {
        if (!e.predicates) {
          e.predicates = [];
        }
        if (~e.predicates.indexOf('!')) {
          e.predicates.pop('!');
        } else e.predicates.push('!');
      }
    });
    this.changed();
  }

  toggleFilter(filter) {
    if (this.hasFilter(filter)) {
      this.removeFilter(filter.dimension, filter.value);
    } else {
      // if (this.isViewChat && filter.dimension === 'agent_dialog@members:members' ) {
      //   this.filters = this.filters.filter(f => f.dimension !== filter.dimension);
      // }
      this.addFilter(filter.dimension, filter.value, filter.label);
    }
  }

  reSetFilter(filter) {
    this.cleanFilter(filter.dimension);
    this.addFilter(filter.dimension, filter.value, filter.label);
  }

  addCut(cut) {
    if (!this.hasFilter(cut)) {
      this.addFilter(cut.dimension, cut.value, cut.label);
    }
  }

  viewModeType() {
    const params = this.buildQueryParams();
    let eventtype = '';
    let c = 0;
    if (params && params.dim && params.dim.length) {
      for (let i = 0; i < params.dim.length; i++) {
        if (params.dim[i] === 'agent_eventtype@default:agent_eventtype') {
          eventtype = params.filter[i];
          c++;
          if (c === 2) {
            break;
          }
        }
      }
    }
    return c == 1 ? eventtype : null;
  }

  count(fieldName) {
    if (this.children && this.children.length) {
      return this.children.reduce((prev, child) =>
        prev + (child.count ? child.count(fieldName) : 0),
        this[fieldName]);
    }
    return this[fieldName];
  }

  hasProp(fieldName) {
    if (this.children && this.children.length) {
      return this.children.some(f => f.hasProp(fieldName));
    }
    return !!this[fieldName];
  }

  /**
   * Builds Server query parameters based on current values.
   */
  buildQueryParams() {
    const params = {};
    const drilldown = this.drilldown.slice(0);

    if (this.time_filter) {
      params['time_filter'] = 'time_registered';
    }

    // Include drilldown array
    if (drilldown.length > 0) {
      params['drill'] = drilldown;
    }

    // Include filters
    const dims = [];
    const filters = [];

    if (this.isChartArea) {
      params['chartAreaType'] = this.chartAreaType;
      params['chartAreaIsStacked'] = this.chartAreaIsStacked;
    }

    if (this.isGraph) {
      params['measure'] = this.measure;
    }

    this.filters.forEach((e) => {
      dims.push(e.dimension);
      filters.push((e.predicates ? e.predicates.join('') : '') + e.value);
    });

    if (dims.length) {
      params['dim'] = dims;
      params['filter'] = filters;
    }

    if (this.order) {
      params['order'] = this.order;
      params['dir'] = this.orderDir;
    }

    if (this.isAnomaly || this.threshold) {
      params['threshold'] = this.threshold;
    }

    if (!this.facts_count) {
      if (this.timeFrom) {
        params['time_from'] = Filter.dateToUrl(this.timeFrom);
      }
      if (this.timeTo) {
        params['time_to'] = Filter.dateToUrl(this.timeTo);
      }
    }

    if (this.top_len) {
      params.top_len = this.top_len;
    }

    params.page = this.page;
    if (this.facts_count) {
      if (this.facts_count < HARD_LIMIT) {
        params.limit = this.facts_count;
      } else {
        params.limit = HARD_LIMIT;
      }
    } else {
      params.limit = this.limit;
    }

    if (this.lookup) {
      params.lookup = this.lookup;
    }

    if (this.simular) {
      params.simular = this.simular;
    }

    params.id = this.id;
    if (this.hasQuery) {
      params.query = JSON.stringify(this.query);
    }

    if (window.BACKEND) params.backend = window.BACKEND;

    return params;
  }

  getCutsCode() {
    return Filter.getFiltersQueryCode(this.filters, this.query);
  }

  as_text() {
    return Filter.getFiltersText(this.filters);
  }

  static getFiltersQueryCode(filters, query) {
    const filtersText = this.getFiltersText(filters);
    const queryText = query ? JSON.stringify(JSON.parse(angular.toJson(query)), null, ' ') : '';
    return `${filtersText}
${queryText}`;
  }

  static getFiltersText(filters) {
    return filters.reduce(function(previousValue, currentItem) {
      const predicates_value = currentItem.predicates ? currentItem.predicates.reduce(
        function(p, c) {
          return c + p;
        },
        '',
      ) : '';
      let line = currentItem.dimension + '=' + predicates_value + currentItem.value;
      if (currentItem.value != currentItem.label) {
        line += '#' + currentItem.label;
      }
      return previousValue + line + '\n';
    }, '');
  }


  static getQueryFromText(text) {
    const getJson = text => {
      let i1 = -1;
      let counter = 0;
      for (let i = 0; i < text.length; i++) {
        if (text[i] === '{') {
          counter++;
          if (i1 === -1) i1 = i;
        } else if (text[i] === '}') {
          counter--;
          if (!counter && i > i1) return text.substring(i1, i + 1);
        }
      }
      return '';
    };

    const isValidQueryText = text => {
      return !!text.match(/(?=.*\boperator\b)*(?=.*\brules\b)/);
    };

    let textQuery = getJson(text);
    if (!isValidQueryText(textQuery)) {
      textQuery = '{\n  "operator": "AND",\n  "rules": []\n }';
    }
    return JSON.parse(textQuery);
  }

  static getFiltersFromText(text) {
    const getNotJson = fText => {
      const regExp = /{[^{}]*}/gm;
      let prevText;
      do {
        prevText = fText;
        fText = prevText.replace(regExp, '');
      } while (fText != prevText);
      return fText;
    };

    return getNotJson(text).split('\n').filter(function(s) {
      return (!!s);
    }).map(function(f) {
      let label = '';
      let value;
      let dim;
      let valpart;
      if (f.indexOf('=') >= 0) {
        dim = f.split('=')[0];
        valpart = f.split('=')[1];
        if (valpart.indexOf('#') >= 0) {
          value = valpart.split('#')[0];
          label = valpart.split('#')[1];
        } else {
          value = valpart;
        }
      } else {
        dim = 'keyword';
        value = '+' + f;
        label = f;
      }
      const predicates_list = ['~', '+', '&', '!'];
      const predicates = [];
      let i = 0;
      while (predicates_list.indexOf(value[i]) >= 0 && i < value.length) {
        predicates.push(value[i]);
        i += 1;
      }
      value = value.substr(i);
      if (!label) label = value;
      return {
        'dimension': dim,
        'value': value,
        'label': label,
        'predicates': predicates,
      };
    });
  }

  from_text(text) {
    this.filters = Filter.getFiltersFromText(text);
    this.changed();
  }

  getPath(filter) {
    if (this.id === filter.id) {
      return [];
    }
    for (let i = 0; i < this.children.length; ++i) {
      const f = this.children[i];
      const path = f.getPath(filter);
      if (path) {
        return [this, ...path];
      }
    }
  }

  static locLabel(filter) {
    return filter.dimension === 'agent_agent@last_report:last_report' ?
      gettext(filter.label) : (filter.label ? filter.label : gettext('Значение не указано'));
  }

  static orderForTimeDimension(dimension) {
    const levels = {
      'agent_time@hour:hour': 'agent_time.hour',
      'agent_time@y:year': 'agent_time.year',
      'agent_time@ym:month': 'agent_time.year,agent_time.month',
      'agent_time@ymd:day': 'agent_time.year,agent_time.month,agent_time.day',
      'agent_time@ymdh:hour': 'agent_time.year,agent_time.month,agent_time.day,agent_time.hour',
      'agent_time@ymdhm:minute': 'agent_time.year,agent_time.month,agent_time.day,agent_time.hour,agent_time.minute',
    };
    return levels[dimension];
  }

  static isTimeDimension(dimension) {
    return dimension &&
      dimension !== 'agent_time@time_zone:time_zone' &&
      dimension !== 'agent_time@hour:hour' &&
      dimension !== 'agent_time@weekday:weekday' &&
      dimension.indexOf('agent_time') === 0;
  }

  static timeDimensionForLevel(level) {
    const levels = [
      'agent_time@y:year',
      'agent_time@ym:month',
      'agent_time@ymd:day',
      'agent_time@ymdh:hour',
      'agent_time@ymdhm:minute',
    ];
    return levels[level - 1];
  }

  static levelsToTime(levels) {
    if (levels.length === 1) {
      const date = new Date();
      date.setFullYear(levels[0]);
      return date;
    }
    levels[1]--;

    function applyToConstructor(constructor, argArray) {
      const args = [null].concat(argArray);
      const FactoryFunction = constructor.bind.apply(constructor, args);
      return new FactoryFunction();
    }

    //             return new Date( Date.UTC.apply( Date, levels ) );
    return applyToConstructor(Date, levels);
  }

  static valueForTime(date, level, isUTCtime) {
    if (!isUTCtime) {
      date = Filter.toUTCTime(date);
    }
    const levels = [
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
    ];
    return levels.splice(0, level).join(PATH_STRING_SEPARATOR); // inverted comma
  }

  static toUTCTime(date, level) {
    return new Date(date.getUTCFullYear(),
      date.getUTCMonth(), date.getUTCDate(),
      date.getUTCHours(), date.getUTCMinutes(),
      date.getUTCSeconds(),
    );
  }

  static labelForTime(date, level) {
    const format = [
      'YYYY', 'MMM-YYYY', 'DD-MMM-YYYY',
      'DD-MMM-YYYY HH:00-HH:59', 'DD-MMM-YYYY HH:mm',
    ][level - 1];
    return moment(date).format(format);
  }

  static dateToUrl(date) {
    // if (!(date instanceof Date)) return date;
    if (!date.getFullYear) return date;
    return `${date.getFullYear()}-${('0' + String(date.getMonth() + 1)).slice(-2)}-\
${('0' + date.getDate()).slice(-2)}T${('0' + date.getHours()).slice(-2)}:\
${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}.\
${('00' + date.getMilliseconds()).slice(-3)}`;
  }

  static urlToDate(text) {
    let date = new Date(Date.parse(text));
    if (isNaN(date.getTime())) {
      // carry about html2pdf
      date = new Date(Date.parse(text + 'Z'));
      if (isNaN(date.getTime())) {
        return null;
      }
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    }
    return date;
  }
}

// GUI state
Filter.prototype.id = 0;
Filter.prototype.mode = DEFAULT_MODE; // explore, chart, report, stat
Filter.prototype.listType = 'table'; // full or brief or table
Filter.prototype.url = '/analytics/report/aggregate/index/';
Filter.prototype.content_type = 'filter';
Filter.prototype.threshold = 10;

// Cube slice
Filter.prototype.drilldown = [];
Filter.prototype.filters = DEFAULT_FILTERS;

Filter.prototype.children = [];

Filter.prototype.dimension = DEFAULT_DRILL;

Filter.prototype.measure = 'record_count';

// Time range
Filter.prototype.timeFrom = null;
Filter.prototype.timeTo = null;

// Paginator
Filter.prototype.page = 0;
Filter.prototype.limit = DEFAULT_FILTER_LIMIT;

Filter.prototype.order = 'record_count';
Filter.prototype.orderDim = null;
Filter.prototype.orderDir = 'desc';

Filter.prototype.shared = false;
Filter.prototype.saved = false;

Filter.prototype.category = 'neutral';
Filter.prototype.cardWidth = 12;
Filter.prototype.cardHeight = 0;

Filter.prototype.orders = ['measure'];
Filter.prototype.orderDirs = ['desc'];

Filter.prototype.chartAreaType = 'bar';

Filter.prototype.apply_users = [];
Filter.prototype.do_scan = false;
Filter.prototype.email_body_template = '';
Filter.prototype.email_subject_template = '';
Filter.prototype.emails = '';
Filter.prototype.facts_count = 0;
Filter.prototype.mail_login = '';
Filter.prototype.mail_password = '';
Filter.prototype.mail_server = '';
Filter.prototype.notify = false;
Filter.prototype.orientation = false;
Filter.prototype.record_count = false;
Filter.prototype.reporting_schedule_type = '';
Filter.prototype.save_on_disk = false;
Filter.prototype.send_threshold = false;
Filter.prototype.split_by_user = false;
Filter.prototype.threshold_period = null;
Filter.prototype.threshold_type = '';
Filter.prototype.notifyIsHtml = false;
Filter.prototype.notifyIsPdf = false;



// WEBPACK FOOTER //
// ./src/common/filter.js